"use client";

import Toast from "@/components/design-system/toast";
import { hidePasswordChangeToast, showPasswordChangeToast } from "@/store/confirmPasswordChangeSlice";
import { AppState } from "@/store/store";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

const SUCCESS_TITLE = "Password Reset Successful";
const SUCCESS_BODY = "Your password has been successfully changed, and we have logged you in";

const ConfirmPasswordChangeToast = () => {
  const dispatch = useDispatch();
  const showToast = useSelector((state: AppState) => state.confirmPasswordChangeSlice.showToast);
  const toastMessage = useSelector((state: AppState) => state.confirmPasswordChangeSlice.toastMessage);
  const toastType = useSelector((state: AppState) => state.confirmPasswordChangeSlice.toastType);
  const hasFiredRef = useRef(false);

  // The password-reset flow redirects to /?origin=successful-password&loginComplete=true.
  // Show the confirmation toast once from that flag on the landing page.
  //
  // Read window.location.search directly (this effect is client-only) instead of
  // useSearchParams(): on statically-rendered routes the hook does not reliably deliver
  // the param to this layout-mounted component in the production build, so the toast
  // never fired on UAT even though the param was in the URL. The ref guard prevents the
  // 6s auto-dismiss from re-triggering while the flag is still present.
  useEffect(() => {
    if (hasFiredRef.current) return;
    const origin = new URLSearchParams(window.location.search).get("origin");
    if (origin === "successful-password") {
      hasFiredRef.current = true;
      dispatch(showPasswordChangeToast(SUCCESS_TITLE));
    }
  }, [dispatch]);

  return (
    <Toast
      toastMessage={toastMessage}
      toastSubMessage={SUCCESS_BODY}
      toastType={toastType}
      showToast={showToast}
      showOnMobile
      showCloseButton
      showToastTime={6000}
      hideToast={hidePasswordChangeToast}
      toastLocation="top"
    />
  );
};

export default ConfirmPasswordChangeToast;
